import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import * as baseActions from 'actions/base';
import * as driverActions from 'actions/drivers';
import * as userActions from 'actions/users';
import * as vehicleActions from 'actions/vehicles';
import * as dedicatedContractActions from 'actions/dedicated-contracts';

import { getCurrentCarrier } from 'redux/modules/carrier-section/selectors';

import { updateCarrier } from 'actions/carriers';
import {
  driverUpdated,
  carrierUpdated as carrierUpdatedAction,
} from 'redux/modules/carrier-section/effects';

import DriverEditModal from 'components/DriverEditModal';
import { DRIVER_STATES } from 'components/CarrierDetails/Constants';
import { isPreferencePresent, ALLOW_STATE_UPDATE } from 'modules/preferences-manager/preferences';

const actionCreators = {
  ...driverActions,
  ...userActions,
  ...baseActions,
  ...vehicleActions,
  driverUpdated,
  ...dedicatedContractActions,
  updateCarrier,
  carrierUpdated: carrierUpdatedAction,
};

class CarrierDriverEdit extends Component {
  render() {
    const {
      drivers,
      updateDriverUser,
      createDriver,
      createUser,
      updateDriver,
      removeDriver,
      checkUsername,
      updateUser,
      match,
      carrier,
      onCloseModal,
      driverUpdated,
      allowStateUpdate,
      carrierUpdated,
      isAddDriverLite,
    } = this.props;

    if (!carrier) {
      return null;
    }

    const selectedDriver = parseInt(match.params.driver_id, 10);

    const currentDriver = drivers.find((driver) => driver.id === selectedDriver);
    const currentDriverUser = ((currentDriver || {}).user_set || [])[0];

    const onSaveSuccesfully = (newDriver) => {
      if (selectedDriver) {
        driverUpdated(selectedDriver);
      } else {
        driverUpdated(newDriver.id);
      }
      onCloseModal();
    };

    return carrier ? (
      <Fragment>
        {currentDriver ? (
          <DriverEditModal
            isAddDriverLite={isAddDriverLite}
            show={true}
            onClose={onCloseModal}
            carrier={carrier}
            driver={currentDriver}
            user={currentDriverUser}
            onSave={(driver, user, originalUser) =>
              new Promise((resolve, reject) =>
                driver.id
                  ? user
                    ? checkUsername(user.username).then((exist) => {
                        return !exist || user.username === originalUser.username
                          ? updateDriver({
                              ...driver,
                              carrier: undefined,
                              contact_phone: user.phone,
                            })
                              .then(() =>
                                updateUser(
                                  user.id,
                                  {
                                    ...user,
                                    is_active: undefined,
                                  },
                                  driver.status !== DRIVER_STATES.removed ? driver.id : null
                                )
                                  .catch((err) => {
                                    reject(err);
                                  })
                                  .then(resolve)
                              )
                              .catch((err) => {
                                reject(err);
                              })
                          : reject({ username: 'exist' });
                      })
                    : checkUsername(user.username).then((exist) =>
                        !exist
                          ? createUser(
                              {
                                ...user,
                                is_driver: true,
                                driver: driver.url,
                              },
                              driver.id
                            ).then(
                              updateDriver({
                                ...driver,
                                carrier: undefined,
                                contact_phone: user.phone,
                              }).then(resolve)
                            )
                          : reject({ username: 'exist' })
                      )
                  : null
              )
            }
            remove={async (oldDriver) => {
              const newDriver = await removeDriver({
                ...oldDriver,
              });
              onCloseModal();
              if (newDriver.status === DRIVER_STATES.removed) {
                carrierUpdated(carrier.id);
              }
            }}
            onSaveSuccesfully={onSaveSuccesfully}
            onResetPassword={(userId) => {
              const newPassword = Math.random().toString(10).slice(2, 6);
              return updateDriverUser(userId, newPassword).then(() => newPassword);
            }}
            allowStateUpdate={allowStateUpdate}
          />
        ) : (
          <DriverEditModal
            isAddDriverLite={isAddDriverLite}
            show={true}
            onClose={onCloseModal}
            carrier={carrier}
            allowStateUpdate={allowStateUpdate}
            onSave={(driver, user) =>
              new Promise((resolve, reject) =>
                checkUsername(user.username)
                  .then((exist) =>
                    !exist
                      ? createDriver({
                          ...driver,
                          contact_phone: user.phone,
                          carrier: carrier.url,
                          user: user,
                        }).then((newDriver) => {
                          resolve(newDriver);
                        })
                      : reject({ username: 'exist' })
                  )
                  .catch((err) => {
                    console.error(err);
                    if (err.response) {
                      return err.response.json().then(reject);
                    }
                    reject(err);
                  })
              )
            }
            onSaveSuccesfully={onSaveSuccesfully}
          />
        )}
      </Fragment>
    ) : null;
  }
}

CarrierDriverEdit.propTypes = {
  checkUsername: PropTypes.func,
  createUser: PropTypes.func,
  createDriver: PropTypes.func,
  updateDriver: PropTypes.func,
  removeDriver: PropTypes.func,
  drivers: PropTypes.array,
  updateDriverUser: PropTypes.func,
  updateUser: PropTypes.func,
  match: PropTypes.object,
  carrier: PropTypes.object,
  onCloseModal: PropTypes.func,
  driverUpdated: PropTypes.func,
  allowStateUpdate: PropTypes.bool,
  carrierUpdated: PropTypes.func,
};

export default connect((state, { match }) => {
  const currentCarrier = getCurrentCarrier(state);
  const allowStateUpdate = isPreferencePresent(state.me, ALLOW_STATE_UPDATE);

  return {
    allowStateUpdate,
    carrier: currentCarrier,
    drivers: (currentCarrier || {}).drivers,
  };
}, actionCreators)(CarrierDriverEdit);
